import { DialogType } from '@philips-emr/hpms-stipulator-commons';

export function isDialogInformation(type?: DialogType): boolean {
  return type === DialogType.INFORMATION;
}
